import { postReq } from './../infra/http';
import { UpsertUser, UserPaginationFilterRequest, RoleEnum } from '@/models/user.model';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { User } from "@/models/user.model";

export const getPagedUsers = async (input: UserPaginationFilterRequest): Promise<PagedResponseModel<User>> => {
  return await getReq(createUrl("a/Users/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getUsersLookup = async (text?: string, role?: RoleEnum, page?: number): Promise<PaginatedSelectModel> => {
  const model: UserPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: text,
    isAscending: false,
    role: role
  };
  return await getPagedUsers(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `${itm.username} | ${itm.firstName} ${itm.lastName}`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getUser = async (id: number): Promise<BaseResponseModel<User>> => {
  return await getReq(createUrl(`a/Users/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const getUserToken = async (id: number): Promise<BaseResponseModel<string>> => {
  return await getReq(createUrl(`a/Users/GetToken/${id}`),
  ).then((res: any) => res.data);
};

export const getUserStravaToken = async (id: number): Promise<BaseResponseModel<string>> => {
  return await getReq(createUrl(`a/Users/Strava/GetToken/${id}`),
  ).then((res: any) => res.data);
};

export const sendTestPushNotification = async (id: number): Promise<BaseResponseModel<string>> => {
  return await postReq(createUrl(`a/Users/SendTestPushNotification/${id}`), {}
  ).then((res: any) => res.data);
};

export const upsertUser = async (input: UpsertUser): Promise<BaseResponseModel<User>> => {
  return await postReq(createUrl("a/Users/Upsert"),
    input
  ).then((res: any) => res.data);
};